/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates.
 * The Universal Permissive License (UPL), Version 1.0
 * as shown at https://oss.oracle.com/licenses/upl/
 * @ignore
 */

import { useContext } from 'preact/hooks';
import { BusyStateContext } from './BusyStateContext';

/**
 * Utility hook for consuming the Context
 */
export function useBusyStateContext() {
  return useContext(BusyStateContext);
}
